import { NationalIdType } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

const NationalIdTypeForBusiness = [NationalIdType.CIF];

export const NationalIdTypeSelectItems = NationalIdTypeForBusiness.map((value) => ({
  value: value.toLowerCase(),
  display: <Text tId={value.toLowerCase()} />,
}));
